import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './css/KidStories.module.css';

const KidStoryCard = ({ story }) => {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);

  const handleWatchNow = () => {
    navigate(`/video/${story.slug}`, { state: { documentary: story } });
  };

  return (
    <div 
      className={styles.cardContainer}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className={styles.thumbnailContainer}>
        {/* Use computer_image_url as thumbnail; fallback to mobile_image_url if needed */}
        <img
          src={story.computer_image_url || story.mobile_image_url}
          onClick={handleWatchNow}
          alt={story.title}
          className={styles.thumbnail}
        />
        
        {/* Play button that appears on hover */}
        {isHovered && (
          <div className={styles.playButtonOverlay} onClick={handleWatchNow}>
            <div className={styles.playButton}>
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="rgba(0,0,0,0.5)" />
                <path d="M16 12L10 16.5V7.5L16 12Z" fill="white" />
              </svg>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default KidStoryCard;